import { render, staticRenderFns } from "./CulturalEventListItem.vue?vue&type=template&id=4b7498dc&scoped=true"
import script from "./CulturalEventListItem.vue?vue&type=script&lang=js"
export * from "./CulturalEventListItem.vue?vue&type=script&lang=js"
import style0 from "./CulturalEventListItem.vue?vue&type=style&index=0&id=4b7498dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7498dc",
  null
  
)

export default component.exports